export function readMore(value?: string, maxChars = 30): string | undefined {
    if (!value) return '';
    return value.length > maxChars ? `${value.slice(0, maxChars)}...` : value;
}
